import MemoryPage from '../../src/pages/MemoryPage';

export default MemoryPage;
